<div class="badge">
    <div on:click={openProfile} class="image" style="background-image:url('{$profile.img}');"></div>
    <div>
        <div class="name">{$profile.name}</div>
        <div class="points">Punkti: {Math.floor($points)}</div>
    </div>
</div>

<style>
.badge{
    width: 100%;
    height: 100px;
    background: linear-gradient(180deg, #F8961E 0%, #F3722C 100%);
    box-shadow: 0px 5px 15px -7px rgba(0, 0, 0, 0.25);
    border-radius: 0px 0px 90px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #fff;
    position: relative;
    z-index:10;
}
.image{
    box-shadow: inset 0px 8px 4px -7px rgba(0, 0, 0, 0.25);
    width: 100px;
    height: 100px;
    background-size: contain;
    background-position: 50% 50%;
    border-radius: 50%;
    background-color: #fff;
    margin: 20px;
}
.name{
    font-size: 1.5em;
    font-weight: bold;
}
.points {
    color: var(--tera);
}
</style>

<script>
import { profile } from "../../stores/profile"
import { points } from "../../stores/index"
import { showProfile } from "../../stores/index"

const openProfile = () => showProfile.set(true)
</script>